import 'vendor.flickity'

class RelatedCollections extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {

    if (this.initialised){
      return;
    }

    this.bindElements();

    if (!this.sliderContainer){
      console.error('No slider to initialise');
      return;
    }

    this.bindData();

    this.bindEvents();

    this.dispatchEvent(new CustomEvent('RelatedCollections:ready', { bubbles: true }));
    this.initialised = true;
  }

  bindEvents() {
    const self = this;
    self.onPageLoad();
  }

  onPageLoad() {
    const self = this;

    self.initSlider();

  }

  initSlider() {
    const self = this;

    let baseSliderConfig = {
      lazyLoad: true,
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      freeScrollFriction: .075,
      setGallerySize: !0
    };

    self.slider = new Flickity(self.sliderContainer, baseSliderConfig);
  }

  bindElements() {
    this.sliderContainer = this.querySelector('.slider');
  }

  bindData() {
    const self = this;

  }

}

customElements.define('related-collections', RelatedCollections);